/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AdminPost {
  login: string;
  /** @example "Иванов Игорь" */
  displayName: string;
  /** @example "ivanov@mail.com" */
  email: string;
  roles: ("superadmin" | "supervisor" | "manager")[];
}

export type Admin = AdminPost & {
  status: "active" | "inactive";
};

export interface AdminPatch {
  /** @example "Иванов Игорь" */
  displayName: string;
  status: "active" | "inactive";
  roles: ("superadmin" | "supervisor" | "manager")[];
}

export interface AdminClient {
  /** @example "adm1" */
  login: string;
  /** @example "client_login" */
  client: string;
  /** @example "ООО Ромашка" */
  name: string;
  roles: ("impersonate" | "suggest" | "sug-report" | "view" | "order")[];
}

export interface AdminClientPut {
  roles: ("impersonate" | "suggest" | "sug-report" | "view" | "order")[];
}

export interface ClientRich {
  /** @example "my-login" */
  login?: string;
  /** @example "ООО Гарант плюс" */
  name?: string;
  roles?: ("suggest" | "orders")[];
  logisticGroup?: {
    code: string;
    name: string;
  };
  warehouse?: {
    address: string;
  };
  mop?: {
    name: string;
    phone: string;
    email: string;
  };
  mrk?: {
    name: string;
    phone: string;
    email: string;
  };
  class?: string;
  isUU?: boolean;
  participantType?: "physical" | "legal";
  rbCommission?: number;
  /** Остаток кредитного лимита из сервиса orders */
  currentCreditLimit?: number;
  extraCharge?: number;
  discount?: number;
  postponement?: number;
  clientCreditLimit?: number;
  overdueSum?: number;
  overdueDays?: number;
  prepaymentAmount?: number;
  holding?: string;
}

export interface Client {
  /** @example "my_login" */
  login: string;
  /** @example "ООО Гарант плюс" */
  name: string;
  deliveryDayType: "calendar" | "work";
  status: "enabled" | "disabled";
  logisticGroup: {
    code: string;
    name: string;
  };
  groups: {
    code: string;
    name: string;
  }[];
  profile?: any;
  orders?: any;
}

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || "https://admin.atez.ru/api" });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Admin Gateway API
 * @version 0.0.1
 * @baseUrl https://admin.atez.ru/api
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  login = {
    /**
     * @description Login
     *
     * @tags Login
     * @name LoginCreate
     * @summary Login
     * @request POST:/login
     * @secure
     */
    loginCreate: (
      data: {
        login?: string;
        password?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /**
           * @format jwt
           * @example "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c"
           */
          access_token: string;
          /**
           * In seconds
           * @example 600
           */
          expires_in: string;
        },
        any
      >({
        path: `/login`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.UrlEncoded,
        format: "json",
        ...params,
      }),
  };
  impersonate = {
    /**
     * @description Impersonate
     *
     * @tags Impersonate
     * @name ImpersonateCreate
     * @summary Impersonate
     * @request POST:/impersonate
     * @secure
     */
    impersonateCreate: (
      data: {
        client: string;
        host?: "prod" | "test";
        permissions?: ("view" | "suggest" | "order" | "laximo" | "paymentqrfiz" | "test")[];
        /** @example {"is_admin":"t","ad_login":"ipetrov@zapnsk.ru","ad_name":"Василий"} */
        extra?: Record<string, string>;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          url: string;
        },
        any
      >({
        path: `/impersonate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  admin = {
    /**
     * @description Create admin
     *
     * @tags Admin
     * @name AdminCreate
     * @summary Create admin
     * @request POST:/admin
     * @secure
     */
    adminCreate: (data: AdminPost, params: RequestParams = {}) =>
      this.request<Admin, any>({
        path: `/admin`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get admins
     *
     * @tags Admin
     * @name AdminList
     * @summary Get admins
     * @request GET:/admin
     * @secure
     */
    adminList: (
      query?: {
        limit?: number;
        offset?: number;
        /** @example "my_lo" */
        q?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          total: number;
          items: Admin[];
        },
        any
      >({
        path: `/admin`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update admin
     *
     * @tags Admin
     * @name AdminPartialUpdate
     * @summary Update admin
     * @request PATCH:/admin/{login}
     * @secure
     */
    adminPartialUpdate: (login: string, data: AdminPatch, params: RequestParams = {}) =>
      this.request<Admin, any>({
        path: `/admin/${login}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Reset admin password
     *
     * @tags Admin
     * @name ResetPasswordCreate
     * @summary Reset admin password
     * @request POST:/admin/{login}/reset-password
     * @secure
     */
    resetPasswordCreate: (login: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/admin/${login}/reset-password`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description Set up admin clients
     *
     * @tags Admin Clients
     * @name ClientUpdate
     * @summary Set up admin clients
     * @request PUT:/admin/{login}/client
     * @secure
     */
    clientUpdate: (login: string, data: AdminClient[], params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/admin/${login}/client`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get admin clients
     *
     * @tags Admin Clients
     * @name ClientList
     * @summary Get admin clients
     * @request GET:/admin/{login}/client
     * @secure
     */
    clientList: (
      login: string,
      query?: {
        limit?: number;
        offset?: number;
        /** @example "my_lo" */
        q?: string;
        role?: "impersonate" | "suggest" | "view" | "order" | "sug-report";
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          total: number;
          items: AdminClient;
        },
        any
      >({
        path: `/admin/${login}/client`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Set up admin client
     *
     * @tags Admin Clients
     * @name ClientUpdate2
     * @summary Set up admin client
     * @request PUT:/admin/{login}/client/{clientLogin}
     * @originalName clientUpdate
     * @duplicate
     * @secure
     */
    clientUpdate2: (login: string, clientLogin: string, data: AdminClientPut, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/admin/${login}/client/${clientLogin}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Delete admin client
     *
     * @tags Admin Clients
     * @name ClientDelete
     * @summary Delete admin client
     * @request DELETE:/admin/{login}/client/{clientLogin}
     * @secure
     */
    clientDelete: (login: string, clientLogin: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/admin/${login}/client/${clientLogin}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Get admin clients with extended data
     *
     * @tags Admin Clients
     * @name SearchClientRichCreate
     * @summary Get admin clients with extended data
     * @request POST:/admin/{login}/search-client-rich
     * @deprecated
     * @secure
     */
    searchClientRichCreate: (
      login: string,
      data: {
        name?: string;
        logisticGroup?: string;
        mop?: {
          name?: string;
          phone?: string;
          email?: string;
        };
        mrk?: {
          name?: string;
          phone?: string;
          email?: string;
        };
        orderField?: string;
        orderDirection?: string;
      },
      query?: {
        limit?: number;
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          total: number;
          items: ClientRich[];
        },
        any
      >({
        path: `/admin/${login}/search-client-rich`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  adminClientSearch = {
    /**
     * @description Get admin clients
     *
     * @tags Admin Clients
     * @name AdminClientSearchCreate
     * @summary Get admin clients
     * @request POST:/admin-client-search
     * @secure
     */
    adminClientSearchCreate: (
      data: {
        limit?: number;
        offset?: number;
        clientLogin?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          total: number;
          items: AdminClient;
        },
        any
      >({
        path: `/admin-client-search`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  searchClientFilters = {
    /**
     * @description Search values for filtering
     *
     * @tags Client
     * @name SearchClientFiltersCreate
     * @summary Search values for filtering
     * @request POST:/search-client-filters
     * @secure
     */
    searchClientFiltersCreate: (
      data: {
        limit: number;
        offset: number;
        filter: "logistic_group" | "mop" | "mrk" | "class";
        q?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          total: number;
          items: {
            key: string;
            displayValue: string;
          }[];
        },
        any
      >({
        path: `/search-client-filters`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  searchClient = {
    /**
     * @description Search clients
     *
     * @tags Client
     * @name SearchClientCreate
     * @summary Search clients
     * @request POST:/search-client
     * @secure
     */
    searchClientCreate: (
      data: {
        login?: string;
        logisticGroup?: string;
        mop?: string;
        mops?: string[];
        mrk?: string;
        class?: string;
        classes?: string[];
        participantType?: "legal" | "physycal";
        isUU?: boolean;
        orderField?: "login" | "name" | "logisticGroup" | "mop" | "mrk" | "class";
        orderDirection?: "asc" | "desc";
        limit: number;
        offset: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          total: number;
          items: Client[];
        },
        any
      >({
        path: `/search-client`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  matchFilter = {
    /**
     * @description Match filter
     *
     * @tags Suggest
     * @name MatchFilterCreate
     * @summary Match filter
     * @request POST:/match-filter
     * @secure
     */
    matchFilterCreate: (
      data: {
        client: string;
        proposal: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/match-filter`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  suggest = {
    /**
     * @description Suggest
     *
     * @tags Suggest
     * @name SuggestCreate
     * @summary Suggest
     * @request POST:/suggest
     * @secure
     */
    suggestCreate: (
      data: {
        brand: string;
        article: string;
        client: string;
        useAnalogs?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/suggest`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  suggestBrand = {
    /**
     * @description Suggest brand by article
     *
     * @tags Suggest
     * @name SuggestBrandList
     * @summary Suggest brand by article
     * @request GET:/suggest-brand
     * @secure
     */
    suggestBrandList: (
      query: {
        article: string;
        client: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          total: number;
          items: {
            /** @example "Stellox" */
            name: string;
            /** @example 4095 */
            code: string;
          }[];
        },
        any
      >({
        path: `/suggest-brand`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  searchLocalProposals = {
    /**
     * @description Search local proposals
     *
     * @tags Suggest
     * @name SearchLocalProposalsCreate
     * @summary Search local proposals
     * @request POST:/search-local-proposals
     * @secure
     */
    searchLocalProposalsCreate: (
      data: {
        article: string;
        brand: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          items: any[];
        },
        any
      >({
        path: `/search-local-proposals`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  searchBrandNomenclatureAnalog = {
    /**
     * @description Search nomenclature analogs
     *
     * @tags Nomenclature Analog
     * @name SearchBrandNomenclatureAnalogCreate
     * @summary Search nomenclature analogs
     * @request POST:/search-brand-nomenclature-analog
     * @secure
     */
    searchBrandNomenclatureAnalogCreate: (
      data: {
        brand: string;
        article: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          total: number;
          items: any[];
        },
        any
      >({
        path: `/search-brand-nomenclature-analog`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  brandNomenclatureAnalogTaskLocalUpload = {
    /**
     * @description Upload nomenclature analogs
     *
     * @tags Nomenclature Analog
     * @name BrandNomenclatureAnalogTaskLocalUploadCreate
     * @summary Upload nomenclature analogs
     * @request POST:/brand-nomenclature-analog-task-local-upload
     * @secure
     */
    brandNomenclatureAnalogTaskLocalUploadCreate: (
      data: {
        /** @format binary */
        file?: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          total?: number;
          items?: any[];
        },
        any
      >({
        path: `/brand-nomenclature-analog-task-local-upload`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),
  };
  brandNomenclatureAnalog = {
    /**
     * @description Get nomenclature analog task sources
     *
     * @tags Nomenclature Analog
     * @name TaskSourceList
     * @summary Get nomenclature analog task sources
     * @request GET:/brand-nomenclature-analog/{id}/task-source
     * @secure
     */
    taskSourceList: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          total: number;
          items: any[];
        },
        any
      >({
        path: `/brand-nomenclature-analog/${id}/task-source`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  searchOrderItemFilters = {
    /**
     * @description Search values for filtering
     *
     * @tags Order
     * @name SearchOrderItemFiltersCreate
     * @summary Search values for filtering
     * @request POST:/search-order-item-filters
     * @secure
     */
    searchOrderItemFiltersCreate: (
      data: {
        limit: number;
        offset: number;
        filter:
          | "user_login"
          | "holding"
          | "primary_key"
          | "brand"
          | "article"
          | "mop"
          | "mrk"
          | "supplier"
          | "price_list"
          | "status";
        q?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          total: number;
          items: {
            key: string;
            displayValue: string;
          }[];
        },
        any
      >({
        path: `/search-order-item-filters`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  searchOrderItems = {
    /**
     * @description Search Order Items
     *
     * @tags Order
     * @name SearchOrderItemsCreate
     * @summary Search Order Items
     * @request POST:/search-order-items
     * @secure
     */
    searchOrderItemsCreate: (
      data: {
        /** @format datetime */
        from?: string;
        /** @format datetime */
        to?: string;
        statuses?: any[];
        primaryKeys?: string[];
        clients?: string[];
        users?: string[];
        holdings?: string[];
        mops?: string[];
        mrks?: string[];
        sources?: ("tradesoft" | "client")[];
        return?: ("limited" | "impossible" | "possible" | "unknown")[];
        suppliers?: string[];
        priceLists?: string[];
        isOfficial?: boolean;
        /** @min 0 */
        limit?: number;
        /** @min 0 */
        offset?: number;
        /** @format date-time */
        deliveryDateFrom?: string;
        /** @format date-time */
        deliveryDateTo?: string;
        lateFrom?: number;
        lateTo?: number;
        brands?: string[];
        articles?: string[];
        priceFrom?: number;
        priceTo?: number;
        sumFrom?: number;
        sumTo?: number;
        hasComment?: boolean;
        sort?: {
          direction: "asc" | "desc";
          field:
            | "date"
            | "delivery"
            | "status"
            | "status_date"
            | "primary_key"
            | "price"
            | "sum"
            | "mop"
            | "client"
            | "client_name"
            | "price_list"
            | "supplier"
            | "late";
        }[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          total: number;
          items: any[];
        },
        any
      >({
        path: `/search-order-items`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  searchSuggestionLogFilters = {
    /**
     * @description Search values for filtering
     *
     * @tags Suggestion Log
     * @name SearchSuggestionLogFiltersCreate
     * @summary Search values for filtering
     * @request POST:/search-suggestion-log-filters
     * @secure
     */
    searchSuggestionLogFiltersCreate: (
      data: {
        /** @format datetime */
        from?: string;
        /** @format datetime */
        to?: string;
        client?: string;
        mop?: string;
        holding?: string;
        brand?: string;
        article?: string;
        hasResults?: boolean;
        withAnalogs?: boolean;
        requestedFrom?: string;
        /** @example 1 */
        queryTimeFrom?: number;
        /** @example 1 */
        queryTimeTo?: number;
        limit: number;
        offset: number;
        filter: "article" | "brand";
        q?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          total: number;
          items: {
            key: string;
            displayValue: string;
          }[];
        },
        any
      >({
        path: `/search-suggestion-log-filters`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  searchSuggestionLog = {
    /**
     * @description Get clients suggestion log (use `accept: text/csv` for csv response)
     *
     * @tags Suggestion Log
     * @name SearchSuggestionLogCreate
     * @summary Get clients suggestion log
     * @request POST:/search-suggestion-log
     * @secure
     */
    searchSuggestionLogCreate: (
      data: {
        /** @format datetime */
        from: string;
        /** @format datetime */
        to: string;
        client?: string;
        mop?: string;
        holding?: string;
        brand?: string;
        article?: string;
        hasResults?: boolean;
        withAnalogs?: boolean;
        requestedFrom?: ("tradesoft" | "admin" | "client")[];
        /** @example 1 */
        queryTimeFrom?: number;
        /** @example 1 */
        queryTimeTo?: number;
        limit?: number;
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/search-suggestion-log`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  downloadSuggestionLog = {
    /**
     * No description
     *
     * @tags Suggestion Log
     * @name DownloadSuggestionLogCreate
     * @summary Download clients suggestion log
     * @request POST:/download-suggestion-log
     * @secure
     */
    downloadSuggestionLogCreate: (
      data: {
        /** @format datetime */
        from: string;
        /** @format datetime */
        to: string;
        clients?: string[];
        mop?: string;
        holding?: string;
        brand?: string;
        article?: string;
        hasResults?: boolean;
        withAnalogs?: boolean;
        requestedFrom?: ("tradesoft" | "admin" | "client")[];
        /** @example 1 */
        queryTimeFrom?: number;
        /** @example 1 */
        queryTimeTo?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/download-suggestion-log`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  searchWsSuggestionLog = {
    /**
     * No description
     *
     * @tags Suggestion Log
     * @name SearchWsSuggestionLogCreate
     * @summary Get WS suggestion log
     * @request POST:/search-ws-suggestion-log
     * @secure
     */
    searchWsSuggestionLogCreate: (
      data: {
        /** @format datetime */
        from: string;
        /** @format datetime */
        to: string;
        clients?: string[];
        mop?: string;
        holding?: string;
        brand?: string;
        article?: string;
        hasResults?: boolean;
        withAnalogs?: boolean;
        requestedFrom?: "tradesoft" | "admin" | "client";
        /** @example 1 */
        queryTimeFrom?: number;
        /** @example 1 */
        queryTimeTo?: number;
        limit?: number;
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/search-ws-suggestion-log`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  downloadWsSuggestionLog = {
    /**
     * No description
     *
     * @tags Suggestion Log
     * @name DownloadWsSuggestionLogCreate
     * @summary Download WS suggestion log
     * @request POST:/download-ws-suggestion-log
     * @secure
     */
    downloadWsSuggestionLogCreate: (
      data: {
        /** @format datetime */
        from: string;
        /** @format datetime */
        to: string;
        clients?: string[];
        mop?: string;
        holding?: string;
        brand?: string;
        article?: string;
        hasResults?: boolean;
        withAnalogs?: boolean;
        requestedFrom?: "tradesoft" | "admin" | "client";
        /** @example 1 */
        queryTimeFrom?: number;
        /** @example 1 */
        queryTimeTo?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/download-ws-suggestion-log`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  webSupplier = {
    /**
     * @description Get web suppliers
     *
     * @tags Dictionary
     * @name WebSupplierList
     * @summary Get web suppliers
     * @request GET:/web-supplier
     * @secure
     */
    webSupplierList: (
      query?: {
        /** @example "Гарант Ав" */
        q?: string;
        limit?: number;
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example 1 */
          total?: number;
          items?: any[];
        },
        any
      >({
        path: `/web-supplier`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  callWebSupplier = {
    /**
     * @description Add web supplier
     *
     * @tags Web Supplier
     * @name CallWebSupplierCreate
     * @summary Add web supplier
     * @request POST:/call-web-supplier
     * @secure
     */
    callWebSupplierCreate: (
      data: {
        wsCode: string;
        op: "brand" | "article";
        timeout: number;
        article: string;
        brand?: string;
        withAnalogs?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/call-web-supplier`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
